<!--
  ~ Developed for G.J. Gardner Homes by Softeq Development Corporation
  ~ http://www.softeq.com
-->

<gh-ext-page>
  <gh-ext-page-title title="{{'lbl_shared_documents' | translate}}"></gh-ext-page-title>
  <gh-ext-page-content>
    <ng-container matSort="">
      <!-- Desktop version -->
      <mat-table *ghExtIfQuery="'gt-sm'" ghExtInfiniteTable="" [dataSource]="dataSource" [tracker]="tracker" [trackBy]="getDocId">
        <ng-container matColumnDef="fileName">
          <mat-header-cell fxFlex="75%" *matHeaderCellDef="" mat-sort-header="">{{'lbl_file_name' | translate}}</mat-header-cell>
          <mat-cell fxFlex="75%" *matCellDef="let doc">{{ doc.fileName }}</mat-cell>
        </ng-container>

        <ng-container matColumnDef="fileId">
          <mat-header-cell *matHeaderCellDef=""></mat-header-cell>
          <mat-cell *matCellDef="let doc" class="cell-align-right">
            <button type="button" class="small cell-button" mat-stroked-button="" (click)="view(doc)">{{'lbl_view' | translate}}</button>
          </mat-cell>
        </ng-container>

        <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
        <mat-row *matRowDef="let doc; columns: displayedColumns" [ghExtInfiniteRow]="doc"></mat-row>
      </mat-table>

      <!-- Mobile version -->
      <div *ghExtIfQuery="'lt-md'" fxLayout="column">
        <gh-ext-infinite-list [itemHeight]="170" [tracker]="tracker">
          <mat-card *ghExtInfiniteScrollFor="let doc of dataSource">
            <mat-card-content>
              <div class="card-content-item">
                <div class="card-content-item-title">{{'lbl_file_name' | translate}}</div>
                <div class="card-content-item-value">{{ doc.fileName }}</div>
              </div>
            </mat-card-content>
            <mat-card-actions class="right">
              <button type="button" class="small cell-button" mat-stroked-button="" (click)="view(doc)">{{'lbl_view' | translate}}</button>
            </mat-card-actions>
          </mat-card>
        </gh-ext-infinite-list>
      </div>
      <gh-ext-load-tracker fxFlex="" #tracker="ghExtLoadTracker"></gh-ext-load-tracker>
    </ng-container>
  </gh-ext-page-content>
</gh-ext-page>